import { render, staticRenderFns } from "./FirstPage.vue?vue&type=template&id=fff028d6"
import script from "./FirstPage.vue?vue&type=script&lang=js"
export * from "./FirstPage.vue?vue&type=script&lang=js"
import style0 from "./FirstPage.vue?vue&type=style&index=0&id=fff028d6&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fff028d6')) {
      api.createRecord('fff028d6', component.options)
    } else {
      api.reload('fff028d6', component.options)
    }
    module.hot.accept("./FirstPage.vue?vue&type=template&id=fff028d6", function () {
      api.rerender('fff028d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/price/pricingChange/FirstPage.vue"
export default component.exports